/**
 * Per-user email preferences — opt-in/out of Lenavio email categories.
 *
 * Back-end endpoints live at ``/me/email-preferences``. Only the
 * recipient themselves can read or update their preferences; there is
 * no HR-admin surface (by design — an HR admin can't silently mute an
 * employee's approval emails).
 */
import client from "./client";

export interface EmailCategoryMeta {
  category: string;
  label: string;
  description: string;
}

export interface EmailPreferencesRead {
  /** Map of category value → `opted_out` flag. */
  preferences: Record<string, boolean>;
}

export async function listEmailCategories(): Promise<EmailCategoryMeta[]> {
  const res = await client.get<{ categories: EmailCategoryMeta[] }>(
    "/me/email-preferences/categories",
  );
  return res.data.categories;
}

export async function getMyEmailPreferences(): Promise<EmailPreferencesRead> {
  const res = await client.get<EmailPreferencesRead>("/me/email-preferences");
  return res.data;
}

export async function updateMyEmailPreference(
  category: string,
  optedOut: boolean,
): Promise<EmailPreferencesRead> {
  const res = await client.patch<EmailPreferencesRead>(
    "/me/email-preferences",
    { category, opted_out: optedOut },
  );
  return res.data;
}
